/**
 * Глобальный счетчик изменений мутабельных потоков.
 *
 * Вычисляемым потокам он нужен, чтобы дешево понять, менялся ли хоть один поток за время их
 * расчета. Если счетчик не сдвинулся, поштучно сверять источники не нужно — а такая сверка
 * стоит по вызову `getSnapshot()` на каждый источник.
 */
let revision = 0;

/**
 * Отмечает изменение значения мутабельного потока.
 *
 * @internal
 */
export function bumpFlowRevision(): void {
    revision += 1;
}

/**
 * Возвращает текущее значение счетчика изменений.
 *
 * @returns Счетчик, монотонно растущий с каждым изменением любого мутабельного потока
 * @internal
 */
export function getFlowRevision(): number {
    return revision;
}

/**
 * Сбрасывает счетчик изменений между тестами.
 *
 * @internal
 */
export function resetFlowRevision(): void {
    revision = 0;
}
